export function Chevron() {
  return (
    <svg
      className="dropdown__svg"
      width="18"
      height="9"
      viewBox="0 0 18 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 1L9 8L17 1" stroke="currentColor" strokeWidth="2"  />
    </svg>
  );
}
